import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import MaterialTable from 'material-table';
import { AbilityContext } from '../../config/ability-context'
import * as componentActions from '../../redux/actions/users';
import Footer from '../../components/footer';
import { FormattedMessage,injectIntl } from 'react-intl';
import Api from '../../services/api';
import moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';  

import { getModelsTrained,postModelsTrained,  checkPredictAccess } from '../../services/predict';

class PredictTrainingList extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;


        const { userSession } = this.props;
        const intl = this.props.intl;

     
        
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            file : null,

            totalPages:1,
            page:1,
            pageStart:1,
            pageEnd:1,
            count:0,
            searchValue: '',
            filterSelected: 0,
        };
        var globalAdm = false;
        this.AdmOrganization = false;
        this.userId = userSession.user.id;
        userSession.user.userrole.map((item, key) => {
            if(item.role.roletype ==0){
                globalAdm =true;
            }
            if(item.role.roletype ==1 && globalAdm == false){
                this.AdmOrganization =true;
            }
        });


        this.closeNotification = this.closeNotification.bind(this);

        this.columns = [
            { title: 'Nome', field: 'name', editable: 'never' },
            { title: 'Acuracidade', field: 'accuracy', editable: 'never'  },
            { title: 'Data de Criação', field: 'creation_date', editable: 'never' , render: rowData => moment(rowData.creation_date).format('DD/MM/YYYY HH:mm')  },
            { title: 'Modelo em Uso?', field: 'is_in_use',lookup: {true: 'Sim', false: 'Não'}  },           
          ];
    }

    componentDidMount(){
        this.getItens();
    }

    componentWillReceiveProps(nextProps){
                        if(nextProps.location.state === "reload"){
                            this.componentDidMount();
                        }
                    }    

                    componentDidMount() {
        this.getItens();
    }
   
    setPagination(count,page){
                            
                            let totalPage = Math.ceil (count/10);
                            this.setState({ totalPages:totalPage })
                            if(count > 0){
                                if(page == 1){
                                    if(count < 10){
                                        this.setState({pageStart:1,pageEnd:count});
                                    } else{
                                        this.setState({pageStart:1,pageEnd:10});
                                    }
                                } else{
                                    let pageStart = ((page - 1) * 10) + 1;
                                    
                                    
                                    
                                    if(count >= page * 10){
                                        this.setState({pageStart:pageStart,pageEnd:page * 10});
                                    } else{
                                        this.setState({pageStart:pageStart,pageEnd:count});
                                    }
                                }
                            } else {
                                this.setState({totalPages:0,page:1,count:0});
                            }
                            
    }
    async getItens(page = 1) {
        this.setState({ loading: true });
        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: auto !important');
  
        const result = await getModelsTrained();
        //console.log(result)
        //console.log("componentDidMount")
        if(result && result.data && result.data.success){
          if(result.data.data &&  result.data.data.models){
            let count = result.data.data.models.length;
            this.setState({count:count});
            this.setPagination(count,page);

            this.setState({
              loading: false,
              resultList: result.data.data.models,
            });
          }else{
            this.setState({
              loading: false
            });
          }
          
        }else{
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: "Erro ao processar solicitação",
          });
          Api.kickoff(result);
        }
  
    };

    

    closeNotification() {
        this.setState({ openNotification: false });
    }

    async updateItem(data, resolve) {
        this.setState({ loading: true }); 
        for (let key in data) {
            if (key.toString().toLowerCase().indexOf('starthour') > -1 || key.toString().toLowerCase().indexOf('endhour') > -1) {
                var vl = data[key] ;
            }
        }
      
        data['name'] = data.name;

        //alert(JSON.stringify(data));
        const intl = this.props.intl;

        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: auto !important');
  
        const result = await postModelsTrained(data);
        console.log(result)
        //console.log("componentDidMount")
        //alert(JSON.stringify(result));
        if(result && result.data && result.data.success){
          if(result.data.data){
            this.getItens();

            this.setState({
                openNotification: true,
                notificationVariant: 'info',
                notificationMessage: "Solicitação realizada com sucesso!",
              });
             
          }else{
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "Erro ao processar solicitação",
              });
              Api.kickoff(result);
          }
          
        }else{
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({id:"process.error"})
          });
  
          Api.kickoff(result);
        }
       
    };

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{paddingLeft:0, marginLeft:0}}>
                                <HeaderMenu />
                                <main
                                    className={clsx(classes.content, {
                                        [classes.contentShift]: headerMenu.open,
                                    })}
                                    
                                >
                                    <div className={classes.drawerHeader} />

                                    <Container component='main' maxWidth='xl' style={{paddingLeft:0, marginLeft:0}}>
                                        <CssBaseline />
                                        <Grid container className={classes.mb20}  spacing={0}>
                            
                        </Grid>
                        
                        <MaterialTable
                            title=""
                            columns={this.columns}
                            data={this.state.resultList}
                            rowClick={(event, rowData) => {
                                alert(JSON.stringify(rowData));
                            }}

                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise(resolve => {
                                        setTimeout(() => {
                                            resolve();
                                            this.updateItem(newData,resolve);
                                        }, 600);
                                }),


                            }}
                            localization={{
                                grouping: {
                                  groupedBy: intl.formatMessage({id:"grouped.by"}),
                                  placeholder: intl.formatMessage({id:"headers.drap"})
                                },
                                pagination: {
                                  labelDisplayedRows: '{from}-{to} '+intl.formatMessage({id:"of"}) +' {count}',
                                  labelRowsPerPage: intl.formatMessage({id:"recordsPerPage"}),
                                  labelRowsSelect: intl.formatMessage({id:"records"})
                                },
                                toolbar: {
                                    addRemoveColumns: intl.formatMessage({id:"add.remove"}),
                                    nRowsSelected: '{0}' + intl.formatMessage({id:"rows.select"}),
                                    showColumnsTitle: intl.formatMessage({id:"show.columns"}),
                                    showColumnsAriaLabel: intl.formatMessage({id:"show.columns"}),
                                    exportTitle: intl.formatMessage({id:"export"}),
                                    exportAriaLabel: intl.formatMessage({id:"export"}),
                                    exportName: intl.formatMessage({id:"export.csv"}),
                                    searchTooltip: intl.formatMessage({id:"search"}),
                                    searchPlaceholder: intl.formatMessage({id:"search"})
                                },
                                header: {
                                  actions: intl.formatMessage({id:"action"})          
                                },
                                body: {
                                  emptyDataSourceMessage: intl.formatMessage({id:"rows.show"}),
                                  filterRow: {},
                                  editRow: {
                                    saveTooltip: intl.formatMessage({id:"save"}),
                                    cancelTooltip: intl.formatMessage({id:"cancel"}),
                                    deleteText: intl.formatMessage({id:"sure.delete"})
                                  },
                                  addTooltip: intl.formatMessage({id:"add"}),
                                  deleteTooltip: intl.formatMessage({id:"delete"}),
                                  editTooltip: intl.formatMessage({id:"update"})
                                }
                              }} 

                        />
                     

                        
                                            
                                            <Grid container style={{marginBottom:12,marginTop:8}}>
                                                <Grid item xs={12} md={3}>
                                                <Pagination  count={this.state.totalPages} page={this.state.page}  onChange={this.onChangePaginate} />
                                                </Grid>
                                                <Grid item xs={12} sm={3} style={{marginTop:6}}>
                                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                                </Grid>
                                            </Grid>

                                            
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
               <Footer /> 
            </div>
        );
    }
}

PredictTrainingList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(PredictTrainingList)));

PredictTrainingList.contextType = AbilityContext;
